export default __webpack_public_path__ + "static/media/barcoSeta.49591e99.svg";